var e = {
	sharing: {
		blockedSendError: "This message looks like it contains contact details. You can share them once a booking is confirmed.",
		attachmentsBlockedError: "Attachments can be sent once a booking is confirmed.",
		unlockedCaveat: "Sharing contact info is allowed — just remember that conversations held outside the platform may not be accounted for in case of disputes.",
		infoSharedAlertTitle: "Contact details were shared in this conversation",
		infoSharedAlertBody: "That's allowed — but anything discussed outside the platform may not be accounted for if a dispute arises."
	},
	emptyThread: "No messages yet. Say hello!",
	accessDenied: "This conversation isn't available on this profile. Switch profiles to open it.",
	detailsPanel: {
		title: "Property Details",
		noProperty: "No property linked to this conversation",
		listingFallback: "Listing",
		paymentSummary: "Payment summary",
		showPreviousTrips_one: "Show previous trip ({{count}})",
		showPreviousTrips_other: "Show previous trips ({{count}})",
		hidePreviousTrips_one: "Hide previous trip ({{count}})",
		hidePreviousTrips_other: "Hide previous trips ({{count}})"
	},
	hostDetailsPanel: {
		tabs: {
			notes: "Notes",
			booking: "Booking"
		},
		actions: "Actions",
		earningsBreakdown: "Earnings breakdown",
		inviteToBook: "Invite to Book",
		withdrawInvitation: "Withdraw Invitation",
		withdraw: "Withdraw",
		invitationPending: "Invitation pending — awaiting the guest's response.",
		keepInvitation: "Keep",
		withdrawConfirm: "Are you sure? The guest will no longer be able to accept this invitation and the held dates will be released.",
		toast: {
			withdrawnTitle: "Invitation Withdrawn",
			withdrawnDescription: "The booking invitation has been withdrawn.",
			withdrawFailedTitle: "Withdrawal Failed"
		}
	},
	quickBooking: {
		selectDatesLabel: "Select dates to book",
		bookNow: "Book Now",
		datesRequired: "Select your dates"
	},
	artifacts: {
		genericFallback: "Shared an update",
		fields: {
			guest: "Guest",
			listing: "Listing",
			cleaningFee: "Cleaning fee",
			total: "Total",
			current: "Current",
			new: "New",
			requested: "Requested",
			expires: "Expires",
			expired: "Expired",
			noteFromHost: "Note from host",
			noteFromGuest: "Note from guest",
			yourNote: "Your note",
			nightlyStayTotal: "Nightly Stay Total"
		},
		guestCount_one: "{{count}} Guest",
		guestCount_other: "{{count}} Guests",
		nights_one: "{{count}} night",
		nights_other: "{{count}} nights",
		nightRate_one: "{{price}} × {{count}} night",
		nightRate_other: "{{price}} × {{count}} nights",
		priceDifference: {
			payExtra: "Pay extra {{amount}}",
			refund: "Refund {{amount}}",
			none: "No price difference"
		},
		request: {
			title: "New Booking Request",
			accept: "Accept",
			confirming: "Confirming…",
			viewDetails: "View Details"
		},
		requestSent: {
			title: "Your booking request is on its way!",
			subtitle: "{{listing}} · Awaiting host confirmation"
		},
		confirmation: {
			title: "Bags packed? Your booking is locked in and ready!",
			viewDetails: "View Details"
		},
		rejection: {
			title: "Your booking request was declined",
			subtitle: "{{listing}} · You won't be charged"
		},
		rejectionSent: {
			title: "You declined this booking request",
			subtitleWithGuest: "{{guest}} · {{listing}}"
		},
		invitation: {
			pendingTitle: "Welcome home! You've been invited to secure your stay.",
			acceptedTitle: "Invitation accepted!",
			statusTitle: "Invitation {{status}}"
		},
		invitationSent: {
			title: "Invitation sent!",
			subtitle: "Awaiting the guest's response"
		},
		modification: { title: "Reservation date change" },
		modificationSent: {
			title: "Your modification request was sent!",
			awaitingApproval: "Awaiting host approval"
		},
		review: {
			title: "How was your stay?",
			body: "Share your experience to help other guests.",
			hostTitle: "Review requested",
			hostBody: "We've asked your guest to review their stay. You'll be notified when they do."
		},
		guestDocument: {
			title: "Identity documents shared",
			guest_one: "You shared 1 ID for someone travelling with you. It will be deleted on {{date}}.",
			guest_other: "You shared {{count}} IDs for the people travelling with you. They will be deleted on {{date}}.",
			host_one: "Your guest shared 1 ID for someone travelling with them. It will be deleted on {{date}}.",
			host_other: "Your guest shared {{count}} IDs for the people travelling with them. They will be deleted on {{date}}.",
			locked: "Your guest shared identity documents for this stay. Viewing them needs the Guest documents permission — ask a workspace admin, and do it before the records are deleted after the stay.",
			processing: "The IDs shared for this stay aren't ready to view yet.",
			gone: "The identity documents shared for this stay have been deleted.",
			error: "Couldn't load the identity documents shared for this stay."
		},
		specialOffer: {
			title: "Special offer",
			titleWithListing: "Special offer · {{listing}}",
			percentOff: "{{value}}% off",
			amountOff: "{{amount}} off",
			applyAtCheckout: "Apply this code at checkout.",
			expiresOn: " Expires {{date}}."
		},
		modal: {
			extendTitle: "Extend your stay",
			rescheduleTitle: "Change your dates",
			payDifferenceTitle: "Pay the difference",
			currentDates: "Current dates",
			newCheckoutDate: "New checkout date",
			newDates: "New dates",
			nightsAdded_one: "+{{count}} night added",
			nightsAdded_other: "+{{count}} nights added",
			nightsSelected_one: "{{count}} night selected",
			nightsSelected_other: "{{count}} nights selected",
			extendHint: "Extra nights are added to your stay. You'll pay for the added nights.",
			rescheduleHint: "We'll re-price your new dates. If they cost more you'll pay the difference; if less, you'll be refunded.",
			requestError: "Couldn't request the change. The dates may be unavailable — try different dates.",
			youPayNow: "You pay now",
			paymentDetails: "Payment Details",
			chargeItemName: "Date change difference",
			chargeItemDescription: "Difference for your new reservation dates",
			done: "Done",
			doneRequestSent: "Your request was sent. Your host will review it shortly.",
			doneRefundApplied: "Your dates were updated and a refund for the difference is being processed.",
			doneDatesUpdated: "Your reservation dates were updated.",
			validation: {
				selectNewDates: "Select your new dates",
				selectAtLeastOneNight: "Select at least one night"
			}
		}
	},
	emptyStates: {
		greeting: "Hi, there 👋",
		conversationHint: "Tell us what you need, and we'll handle the rest.",
		widgetHint: "Send a message to {{name}}",
		inbox: {
			title: "No conversations yet",
			description: "Messages about your stays, your bookings and your support requests all arrive here.",
			guest: {
				title: "Your messages live here",
				description: "Ask a host about a stay, keep track of your booking updates, and reach support — all in one place.",
				explore: "Explore stays",
				support: "Message support"
			},
			host: {
				title: "No guest messages yet",
				description: "When a guest asks about one of your listings, the conversation opens here — along with booking requests and replies from support.",
				listings: "View your listings",
				support: "Message support"
			}
		},
		suggestions: {
			available: {
				label: "Is this available?",
				body: "Hi! Is this property still available for viewing?",
				widgetBody: "Hi! Is this property still available?"
			},
			scheduleVisit: {
				label: "Schedule a visit",
				body: "I would like to schedule a visit. When are you available?"
			},
			pricing: {
				label: "Pricing details",
				body: "Could you share the pricing details and any additional fees?"
			},
			area: {
				label: "About the area",
				body: "Can you tell me more about the neighbourhood and nearby amenities?"
			}
		},
		noSelection: {
			title: "No conversation open",
			description: "Pick a conversation from the list, or switch views to see more of them."
		}
	},
	sidebar: {
		title: "Chat",
		searchPlaceholder: "Search conversations...",
		openSearch: "Search conversations",
		closeSearch: "Close search",
		noResults: "No results",
		noResultsHint: "Try adjusting your search or filters.",
		noConversations: "No conversations",
		noConversationsHint: "Your conversations will appear here once you start chatting.",
		noConversationsYet: "No conversations yet",
		filters: {
			active: "Active",
			inquiries: "Inquiries",
			upcoming: "Upcoming",
			staying: "Staying",
			past: "Past",
			archived: "Archived",
			all: "All",
			hosting: "Hosting",
			traveling: "Traveling",
			support: "Support",
			unread: "Unread"
		},
		preview: {
			bookingRequest: "📋 New booking request",
			voiceMessage: "🎙️ Voice message",
			attachment: "📎 Attachment",
			photo: "📷 Photo",
			message: "Message",
			noMessages: "No messages yet"
		},
		archivedCaption: "Archived",
		empty: {
			active: {
				title: "Nothing needs your attention",
				hint: "Older conversations are under Past and All."
			},
			inquiries: {
				title: "No open inquiries",
				hint: "Threads that have not led to a booking yet appear here."
			},
			upcoming: {
				title: "No upcoming stays",
				hint: "Requested and confirmed stays appear here."
			},
			staying: {
				title: "No stay in progress",
				hint: "A conversation moves here while the stay is happening."
			},
			past: {
				title: "No past stays",
				hint: "Conversations from finished stays are kept here."
			},
			archived: {
				title: "Nothing archived",
				hint: "Threads you archive are kept here, out of your other views."
			},
			support: {
				title: "No support conversations",
				hint: "Threads with the support team appear here."
			},
			unread: {
				title: "Nothing unread",
				hint: "Everything in this view has been read."
			}
		},
		rowAccessibilityLabel: "Conversation with {{name}}"
	},
	recentChats: {
		title: "Recent Chats",
		viewAll: "View All",
		emptyListing: {
			title: "No messages about this listing",
			body: "Guest conversations about this listing will appear here."
		}
	},
	notes: {
		empty: "No internal notes yet",
		emptyHint: "Add private memos visible only to your team",
		placeholder: "Write an internal note…",
		addNote: "Add Note"
	},
	header: {
		close: "Close",
		propertyInquiry: "Property Inquiry",
		directMessage: "Direct Message",
		conversationFallback: "Conversation",
		aiSummary: "AI Summary",
		back: "Back",
		details: "Details",
		moreActions: "More actions",
		archive: "Archive",
		unarchive: "Unarchive"
	},
	input: {
		placeholder: "Message",
		widgetPlaceholder: "Type a message...",
		send: "Send",
		messageEmpty: "Message cannot be empty",
		attach: {
			camera: "Camera",
			photos: "Photos",
			file: "File",
			guestId: "Guest ID"
		},
		aria: {
			attachmentOptions: "Attachment options",
			takePhoto: "Take a photo",
			sendMessage: "Send message",
			recordVoiceNote: "Record voice note",
			cancelRecording: "Cancel recording",
			sendVoiceMessage: "Send voice message",
			removeFile: "Remove {{name}}"
		}
	},
	messages: {
		you: "You",
		sending: "Sending…",
		sentAutomatically: "Sent automatically"
	},
	attachments: { viewAllImages: "View all {{count}} images" },
	voiceNote: {
		play: "Play voice note",
		pause: "Pause voice note",
		seek: "Seek voice note"
	},
	summary: {
		title: "AI Summary",
		description: "AI-generated overview of this conversation",
		generating: "Generating summary...",
		error: "Failed to generate summary. Please try again."
	},
	screen: { title: "Messages" }
};
//#endregion
export { e as default };
